import {
  InvalidateQueryFilters,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { ErrorDTO } from "interface";
import { ARTICLE_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";

const updateArticle = async ({ data }: { data: any }) => {
  const update = {
    ...data,
    width: data.uploadImage?.width || data.image?.width || 0,
    height: data.uploadImage?.height || data.image?.height || "0",
    sizePercentage:
      data.uploadImage?.sizePercentage || data.image?.sizePercentage || "100",
  };
  const res = await instance.put(ARTICLE_END_POINTS.update, update);

  let imageUptateRes;
  let thumbnailUptateRes;

  const imageUpdateFormData = new FormData();
  const thumbnailUpdateFormData = new FormData();

  // upload image if any new image was picked by user
  if (data?.uploadImage?.file) {
    imageUpdateFormData.append("Id", String(data.id ?? 0));
    imageUpdateFormData.append("AltText", data?.altText);
    imageUpdateFormData.append("Width", String(data?.uploadImage?.width ?? 0));
    imageUpdateFormData.append(
      "Height",
      String(data?.uploadImage?.height ?? 0)
    );
    imageUpdateFormData.append("SizePercentage", "100");
    imageUpdateFormData.append("File", data?.uploadImage?.file ?? "");

    thumbnailUpdateFormData.append("Id", String(data.id ?? 0));
    thumbnailUpdateFormData.append("AltText", data?.altText);
    thumbnailUpdateFormData.append(
      "Width",
      String(data.uploadImage?.width ?? 0)
    );
    thumbnailUpdateFormData.append(
      "Height",
      String(data.uploadImage?.height ?? 0)
    );
    thumbnailUpdateFormData.append("SizePercentage", "100");
    thumbnailUpdateFormData.append("File", data.uploadImage.file ?? "");

    imageUptateRes = await instance.put(
      ARTICLE_END_POINTS.update_image,
      imageUpdateFormData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    thumbnailUptateRes = await instance.put(
      ARTICLE_END_POINTS.update_thumbnail,
      thumbnailUpdateFormData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  } // update image AltText (if an image was already uploaded)
  else if ((data?.image?.url ?? "").trim().length > 0) {
    imageUpdateFormData.append("Id", String(data.id ?? 0));
    imageUpdateFormData.append("Width", String(data.image.width));
    imageUpdateFormData.append("Height", String(data.image.height));
    imageUpdateFormData.append("SizePercentage", "100");
    imageUpdateFormData.append("AltText", data?.altText);
    thumbnailUpdateFormData.append("Id", String(data.id ?? 0));
    thumbnailUpdateFormData.append("Width", String(data.image.width));
    thumbnailUpdateFormData.append("Height", String(data.image.height));
    thumbnailUpdateFormData.append("SizePercentage", "100");
    thumbnailUpdateFormData.append("AltText", data?.altText);
    imageUptateRes = await instance.put(
      ARTICLE_END_POINTS.update_image,
      imageUpdateFormData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    thumbnailUptateRes = await instance.put(
      ARTICLE_END_POINTS.update_thumbnail,
      thumbnailUpdateFormData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  }

  return {
    updateRes: res?.data,
    updateImageRes: imageUptateRes?.data,
    updateThumbnailRes: thumbnailUptateRes?.data,
  };
};

export const useUpdateArticle = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ARTICLE_END_POINTS.update, ARTICLE_END_POINTS.list],
    mutationFn: updateArticle,
    onError: (e: AxiosError<ErrorDTO>) => {
      toast.error(`${e.response?.data.Message || "خطا در ویرایش مقاله"}`);
    },
    onSuccess: () => {
      toast.success(`مقاله با موفقیت ویرایش شد`);
      queryClient.invalidateQueries([
        ARTICLE_END_POINTS.get,
      ] as InvalidateQueryFilters);
    },
  });
};
